import { createStyles } from "@material-ui/core";

export default createStyles({

  root: {
    margin: "20px",
    maxWidth: "1140px",
    marginLeft: "auto",
    marginRight: "auto",
    padding: "15px"
  }

});